import { CloudDataService } from './cloud-data.service';
import { ObservableResult } from '../../models/result.model';
import {
  AdminMandant,
  Area, DeactivationTicket,
  Duplicate,
  Employee,
  EmployeeDetails, EmployeeUpdateDetails, K2HelpEmployeeTicketData,
  OrgUnitSetting, UserRightsDisableReasonModel
} from '../../models/cloud/cloud.model';
import { AreasComponent } from '../../app/page-modules/administration/areas/areas.component';

export class MockCloudDataService implements CloudDataService {
  getAdminMandants(): ObservableResult<AdminMandant[]> {
    return ObservableResult.ofSuccess([]);
  }

  getOrgUnitSettings(mandantId: number): ObservableResult<OrgUnitSetting[]> {
    return ObservableResult.ofSuccess([]);
  }

  saveOrgUnitSetting(setting: OrgUnitSetting): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  deleteOrgUnitSetting(id: number): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  getAreas(mandantId: number): ObservableResult<Area[]> {
    return ObservableResult.ofSuccess([]);
  }

  saveArea(area: Area): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  deleteArea(mandantId: number, num: number): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  getEmployees(mandantId: number): ObservableResult<Employee[]> {
    return ObservableResult.ofSuccess([]);
  }

  getDuplicates(mandantId: number): ObservableResult<Duplicate[]> {
    return ObservableResult.ofSuccess([]);
  }

  getEmployee(employeeId: number, mandantId: number): ObservableResult<EmployeeDetails> {
    return ObservableResult.ofSuccess();
  }

  updateEmployee(employee: EmployeeUpdateDetails, mandantId: number): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  getUserRightsDisableReasons(): ObservableResult<UserRightsDisableReasonModel[]> {
    return ObservableResult.ofSuccess([]);
  }

  getK2HelpEmployeeData(): ObservableResult<K2HelpEmployeeTicketData[]> {
    return ObservableResult.ofSuccess([]);
  }

  submitDeactivationTicket(ticket: DeactivationTicket): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }
}
